/**
 *  Alaska: Editor
 *  Public: Registration form
 *
 *  @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.data("RegistrationForm", () => ({
        loading: false,

        form: {
            firstName: "",
            lastName: "",
            email: "",
            confirmEmail: "",
            company: "",
            newsletter: false,
        },

        errors: {
            firstName: "",
            lastName: "",
            email: "",
            confirmEmail: "",
        },

        validate() {
            let valid = true;

            this.errors = {
                firstName: "",
                lastName: "",
                email: "",
                confirmEmail: "",
            };

            if (this.form.firstName.trim() === "") {
                this.errors.firstName = "First name is required";
                valid = false;
            }

            if (this.form.lastName.trim() === "") {
                this.errors.lastName = "Last name is required";
                valid = false;
            }


            if (this.form.email.trim() === "") {
                this.errors.email = "Email address is required";
                valid = false;
            } else if (!this.form.email.includes("@")) {
                this.errors.email = "Invalid email address";
                valid = false;
            }

            if (this.form.confirmEmail.trim() === "") {
                this.errors.confirmEmail = "Please confirm your email address";
                valid = false;
            } else if (this.form.email.trim().toLowerCase() !== this.form.confirmEmail.trim().toLowerCase()) {
                this.errors.confirmEmail = "Email addresses do not match";
                valid = false;
            }
            
            return valid;
        },

        async submit() {
            if (!this.validate()) {
                Notification.render(
                    "Please fill out the required fields.", 
                    "error"
                );
                return;
            }

            this.loading = true;

            try {
                const response = await fetch("/alaska/public/", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        controller: "Marketing",
                        action: "eventRegistration",
                        data: this.form,
                    })
                });

                const result = await response.json();
                // console.log(result);

                if (result.type === "success") {
                    Alpine.store("HtmlModal").open_html({
                        title: "Registration Successful",
                        icon: "fa-check-circle",
                        html: `
                            <div class="flex flex-col gap-4 text-center p-5">
                                <p class="text-xl">
                                    Thank you for registering!
                                </p>
                                <p>Your registration has been received successfully.</p>
                            </div>
                        `
                    });

                    this.reset();
                } else {
                    Notification.render(
                        result.message || "Unable to submit your registration.", 
                        "error"
                    );
                }
            } catch (error) {
                console.error('Registration form error:', error);
                Notification.render(
                    "Unable to submit your registration. Please try again.", 
                    "error"
                );
            } finally {
                this.loading = false;
            }
        },

        reset() {
            this.form = {
                firstName: "",
                lastName: "",
                email: "",
                confirmEmail: "",
                company: "",
                newsletter: false,
            };

            this.errors = {
                firstName: "",
                lastName: "",
                email: "",
                confirmEmail: "",
            };
        },
    }));
});
